import {combineReducers} from 'redux'
import types from 'actions/types'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_ADD_PURCHASE_INVOICE_DIALOG:
      return true
    case types.HIDE_ADD_PURCHASE_INVOICE_DIALOG:
      return false
    default:
      return state
  }
}

export const purchaseOrder = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_PURCHASE_INVOICE_DIALOG:
      return action.purchaseOrder
    case types.HIDE_ADD_PURCHASE_INVOICE_DIALOG:
      return null
    default:
      return state
  }
}

export const defaultInvoiceCreateType = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_PURCHASE_INVOICE_DIALOG:
      return state
    case types.PURCHASING_PURCHASE_INVOICE_ADD_ATTEMPT:
      return action.invoiceCreateType
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  purchaseOrder,
  defaultInvoiceCreateType,
})
